import {createAsyncThunk, createSlice} from "@reduxjs/toolkit"
import axios from "axios"
import {ensureWorkspaceTemplate} from "../utils/reduxUtilities"

export const getImportedArticleCountForWorkspace = createAsyncThunk(
	"freeTierTracker/getImportedArticleCount",
	async ({fullWorkspace, workspaceId}, {getState, rejectWithValue}) => {
		const state = getState()
		// sometimes we have the full workspace object before we've set state.workspace.byWorkspace.
		// if that's the case, then we should use the object passed in. Otherwise, we're dealing with an update
		// to the free-tier count after the workspace has instantiated itself, so we can pull that object from the
		// byWorkspace array in the workspace slice.
		const workspace = fullWorkspace ? fullWorkspace : state.workspace.byWorkspace[workspaceId]
		if(workspace.ownerIsFreeTier){
			const {data} = await axios.get(`/api/workspace/${workspace.id}/imports-count`)
			return {importedArticleCount: data.count, workspaceId: workspace.id}
		} else {
			return rejectWithValue("OWNER IS PAID, DONT GET COUNT")
		}
	}
)

const initialState = {
	importedArticleCount: 0,
	workspaceOverLimit: false,
}
const ensureWorkspace = (state, workspaceId) => ensureWorkspaceTemplate(state, workspaceId, initialState)
export const freeTierTrackerSlice = createSlice({
	name: "freeTierTracker",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		setImportedArticleCount: (state, action) => {
			const {importedArticleCount, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			workspace.importedArticleCount = importedArticleCount
		},
		setWorkspaceOverLimit: (state, action) => {
			const {isOverLimit, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			workspace.workspaceOverLimit = isOverLimit
		}
	},
	extraReducers: (builder) => {
		builder.addCase(
			getImportedArticleCountForWorkspace.fulfilled,
			freeTierTrackerSlice.caseReducers.setImportedArticleCount
		)
	}
})

export const {
	setImportedArticleCount,
	setWorkspaceOverLimit,
} = freeTierTrackerSlice.actions

export const selectImportedArticleCount = (state, workspaceId) => state.freeTierTracker.byWorkspace[workspaceId]?.importedArticleCount ?? initialState.importedArticleCount
export const selectWorkspaceOverLimit = (state, workspaceId) => state.freeTierTracker.byWorkspace[workspaceId]?.workspaceOverLimit ?? initialState.workspaceOverLimit

export default freeTierTrackerSlice.reducer